var globals = {};
export function setGlobal(key, value) {
  if (typeof key === undefined) return;
  globals[key] = value;
}
export function getGlobal(key) {
  if (typeof key === undefined) return;
  return globals[key];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-jserror@1.0.13@@ali/aes-tracker-plugin-jserror/es/utils/global.js
// module id = null
// module chunks = 